import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Landing from "./components/Landing";
import Demande from "./components/Demande";
import ContactUs from "./components/ContactUs";
import Support from "./components/Support";

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/fr" element={<Landing />} /> {/* swicth 'fr' to ':language' to apply the multilanguage path */}
        <Route path="/" element={<Landing />} />
        <Route path="/demande-un-devis" element={<Demande />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
